module.exports = __webpack_public_path__ + "img/beta-test-pop-up.ee60ec7c.png";